import * as Types from './operations-public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const minimumAppVersionFragmentDoc = gql`
  fragment minimumAppVersion on MinimumAppVersion {
    android
    ios
  }
`;
export const publicFeaturesFragmentDoc = gql`
  fragment publicFeatures on PublicFeatures {
    adrsOverdueBillAlternativeSettlementMethod
  }
`;
export const pinFragmentDoc = gql`
  fragment pin on Token {
    sessionToken
    status
  }
`;
export const tokensResponseFragmentDoc = gql`
  fragment tokensResponse on TokensResponse {
    accessToken
    refreshToken
  }
`;
export const initiateAuthResponseFragmentDoc = gql`
  fragment initiateAuthResponse on InitiateAuthResponse {
    session
  }
`;
export const authResponseFragmentDoc = gql`
  fragment authResponse on AuthResponse {
    ...tokensResponse
    ...initiateAuthResponse
  }
  ${tokensResponseFragmentDoc}
  ${initiateAuthResponseFragmentDoc}
`;
export const publicUnpaidBillStatementsFragmentDoc = gql`
  fragment publicUnpaidBillStatements on PublicUnpaidBillStatements {
    billStatements {
      id
      unpaidAmount
      lateFeeAmount
      outstandingAmount
      combiniSettlementAvailable
      bankTransferSettlementAvailable
      dueAt
      status
    }
  }
`;
export const ChangePhoneDocument = gql`
  mutation ChangePhone($email: String!, $phone: String!) {
    changePhone(email: $email, phone: $phone)
  }
`;
export type ChangePhoneMutationFn = Apollo.MutationFunction<
  Types.ChangePhoneMutation,
  Types.ChangePhoneMutationVariables
>;

/**
 * __useChangePhoneMutation__
 *
 * To run a mutation, you first call `useChangePhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePhoneMutation, { data, loading, error }] = useChangePhoneMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useChangePhoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ChangePhoneMutation,
    Types.ChangePhoneMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ChangePhoneMutation,
    Types.ChangePhoneMutationVariables
  >(ChangePhoneDocument, options);
}
export type ChangePhoneMutationHookResult = ReturnType<
  typeof useChangePhoneMutation
>;
export type ChangePhoneMutationResult = Apollo.MutationResult<
  Types.ChangePhoneMutation
>;
export type ChangePhoneMutationOptions = Apollo.BaseMutationOptions<
  Types.ChangePhoneMutation,
  Types.ChangePhoneMutationVariables
>;
export const ConfirmResetPhoneNumberPublicDocument = gql`
  mutation ConfirmResetPhoneNumberPublic(
    $email: String!
    $currentPhoneNumber: String!
    $newPhoneNumber: String!
    $otp: String!
    $pinCodeDispatchMethod: PinCodeDispatchMethod
    $recaptchaPlatform: Platform!
    $recaptchaToken: String!
  ) {
    confirmResetPhoneNumberPublic(
      email: $email
      currentPhoneNumber: $currentPhoneNumber
      newPhoneNumber: $newPhoneNumber
      otp: $otp
      pinCodeDispatchMethod: $pinCodeDispatchMethod
      recaptchaPlatform: $recaptchaPlatform
      recaptchaToken: $recaptchaToken
    )
  }
`;
export type ConfirmResetPhoneNumberPublicMutationFn = Apollo.MutationFunction<
  Types.ConfirmResetPhoneNumberPublicMutation,
  Types.ConfirmResetPhoneNumberPublicMutationVariables
>;

/**
 * __useConfirmResetPhoneNumberPublicMutation__
 *
 * To run a mutation, you first call `useConfirmResetPhoneNumberPublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmResetPhoneNumberPublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmResetPhoneNumberPublicMutation, { data, loading, error }] = useConfirmResetPhoneNumberPublicMutation({
 *   variables: {
 *      email: // value for 'email'
 *      currentPhoneNumber: // value for 'currentPhoneNumber'
 *      newPhoneNumber: // value for 'newPhoneNumber'
 *      otp: // value for 'otp'
 *      pinCodeDispatchMethod: // value for 'pinCodeDispatchMethod'
 *      recaptchaPlatform: // value for 'recaptchaPlatform'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useConfirmResetPhoneNumberPublicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ConfirmResetPhoneNumberPublicMutation,
    Types.ConfirmResetPhoneNumberPublicMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ConfirmResetPhoneNumberPublicMutation,
    Types.ConfirmResetPhoneNumberPublicMutationVariables
  >(ConfirmResetPhoneNumberPublicDocument, options);
}
export type ConfirmResetPhoneNumberPublicMutationHookResult = ReturnType<
  typeof useConfirmResetPhoneNumberPublicMutation
>;
export type ConfirmResetPhoneNumberPublicMutationResult = Apollo.MutationResult<
  Types.ConfirmResetPhoneNumberPublicMutation
>;
export type ConfirmResetPhoneNumberPublicMutationOptions = Apollo.BaseMutationOptions<
  Types.ConfirmResetPhoneNumberPublicMutation,
  Types.ConfirmResetPhoneNumberPublicMutationVariables
>;
export const DoResetPhoneNumberPublicDocument = gql`
  mutation DoResetPhoneNumberPublic(
    $email: String!
    $currentPhoneNumber: String!
    $otp: String!
    $recaptchaPlatform: Platform!
    $recaptchaToken: String!
  ) {
    doResetPhoneNumberPublic(
      email: $email
      currentPhoneNumber: $currentPhoneNumber
      otp: $otp
      recaptchaPlatform: $recaptchaPlatform
      recaptchaToken: $recaptchaToken
    )
  }
`;
export type DoResetPhoneNumberPublicMutationFn = Apollo.MutationFunction<
  Types.DoResetPhoneNumberPublicMutation,
  Types.DoResetPhoneNumberPublicMutationVariables
>;

/**
 * __useDoResetPhoneNumberPublicMutation__
 *
 * To run a mutation, you first call `useDoResetPhoneNumberPublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoResetPhoneNumberPublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doResetPhoneNumberPublicMutation, { data, loading, error }] = useDoResetPhoneNumberPublicMutation({
 *   variables: {
 *      email: // value for 'email'
 *      currentPhoneNumber: // value for 'currentPhoneNumber'
 *      otp: // value for 'otp'
 *      recaptchaPlatform: // value for 'recaptchaPlatform'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useDoResetPhoneNumberPublicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.DoResetPhoneNumberPublicMutation,
    Types.DoResetPhoneNumberPublicMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.DoResetPhoneNumberPublicMutation,
    Types.DoResetPhoneNumberPublicMutationVariables
  >(DoResetPhoneNumberPublicDocument, options);
}
export type DoResetPhoneNumberPublicMutationHookResult = ReturnType<
  typeof useDoResetPhoneNumberPublicMutation
>;
export type DoResetPhoneNumberPublicMutationResult = Apollo.MutationResult<
  Types.DoResetPhoneNumberPublicMutation
>;
export type DoResetPhoneNumberPublicMutationOptions = Apollo.BaseMutationOptions<
  Types.DoResetPhoneNumberPublicMutation,
  Types.DoResetPhoneNumberPublicMutationVariables
>;
export const ImpersonateDocument = gql`
  mutation Impersonate($token: String!, $password: String!) {
    impersonate(token: $token, password: $password) {
      sessionToken
      status
    }
  }
`;
export type ImpersonateMutationFn = Apollo.MutationFunction<
  Types.ImpersonateMutation,
  Types.ImpersonateMutationVariables
>;

/**
 * __useImpersonateMutation__
 *
 * To run a mutation, you first call `useImpersonateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateMutation, { data, loading, error }] = useImpersonateMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useImpersonateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ImpersonateMutation,
    Types.ImpersonateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ImpersonateMutation,
    Types.ImpersonateMutationVariables
  >(ImpersonateDocument, options);
}
export type ImpersonateMutationHookResult = ReturnType<
  typeof useImpersonateMutation
>;
export type ImpersonateMutationResult = Apollo.MutationResult<
  Types.ImpersonateMutation
>;
export type ImpersonateMutationOptions = Apollo.BaseMutationOptions<
  Types.ImpersonateMutation,
  Types.ImpersonateMutationVariables
>;
export const InitiateAuthDocument = gql`
  mutation InitiateAuth(
    $email: String!
    $phone: String!
    $pinCodeDispatchMethod: PinCodeDispatchMethod!
    $recaptchaPlatform: Platform!
    $recaptchaToken: String!
  ) {
    initiateAuth(
      email: $email
      phone: $phone
      pinCodeDispatchMethod: $pinCodeDispatchMethod
      recaptchaPlatform: $recaptchaPlatform
      recaptchaToken: $recaptchaToken
    ) {
      ...initiateAuthResponse
    }
  }
  ${initiateAuthResponseFragmentDoc}
`;
export type InitiateAuthMutationFn = Apollo.MutationFunction<
  Types.InitiateAuthMutation,
  Types.InitiateAuthMutationVariables
>;

/**
 * __useInitiateAuthMutation__
 *
 * To run a mutation, you first call `useInitiateAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateAuthMutation, { data, loading, error }] = useInitiateAuthMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      pinCodeDispatchMethod: // value for 'pinCodeDispatchMethod'
 *      recaptchaPlatform: // value for 'recaptchaPlatform'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useInitiateAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InitiateAuthMutation,
    Types.InitiateAuthMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InitiateAuthMutation,
    Types.InitiateAuthMutationVariables
  >(InitiateAuthDocument, options);
}
export type InitiateAuthMutationHookResult = ReturnType<
  typeof useInitiateAuthMutation
>;
export type InitiateAuthMutationResult = Apollo.MutationResult<
  Types.InitiateAuthMutation
>;
export type InitiateAuthMutationOptions = Apollo.BaseMutationOptions<
  Types.InitiateAuthMutation,
  Types.InitiateAuthMutationVariables
>;
export const InitiateMyEmailReminderDocument = gql`
  mutation InitiateMyEmailReminder(
    $phoneNumber: String!
    $pinCodeDispatchMethod: PinCodeDispatchMethod!
    $recaptchaPlatform: Platform!
    $recaptchaToken: String!
  ) {
    initiateMyEmailReminder(
      phoneNumber: $phoneNumber
      pinCodeDispatchMethod: $pinCodeDispatchMethod
      recaptchaPlatform: $recaptchaPlatform
      recaptchaToken: $recaptchaToken
    )
  }
`;
export type InitiateMyEmailReminderMutationFn = Apollo.MutationFunction<
  Types.InitiateMyEmailReminderMutation,
  Types.InitiateMyEmailReminderMutationVariables
>;

/**
 * __useInitiateMyEmailReminderMutation__
 *
 * To run a mutation, you first call `useInitiateMyEmailReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateMyEmailReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateMyEmailReminderMutation, { data, loading, error }] = useInitiateMyEmailReminderMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      pinCodeDispatchMethod: // value for 'pinCodeDispatchMethod'
 *      recaptchaPlatform: // value for 'recaptchaPlatform'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useInitiateMyEmailReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InitiateMyEmailReminderMutation,
    Types.InitiateMyEmailReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InitiateMyEmailReminderMutation,
    Types.InitiateMyEmailReminderMutationVariables
  >(InitiateMyEmailReminderDocument, options);
}
export type InitiateMyEmailReminderMutationHookResult = ReturnType<
  typeof useInitiateMyEmailReminderMutation
>;
export type InitiateMyEmailReminderMutationResult = Apollo.MutationResult<
  Types.InitiateMyEmailReminderMutation
>;
export type InitiateMyEmailReminderMutationOptions = Apollo.BaseMutationOptions<
  Types.InitiateMyEmailReminderMutation,
  Types.InitiateMyEmailReminderMutationVariables
>;
export const InitiateResetPhoneNumberPublicDocument = gql`
  mutation InitiateResetPhoneNumberPublic(
    $email: String!
    $currentPhoneNumber: String!
    $recaptchaPlatform: Platform!
    $recaptchaToken: String!
  ) {
    initiateResetPhoneNumberPublic(
      email: $email
      currentPhoneNumber: $currentPhoneNumber
      recaptchaPlatform: $recaptchaPlatform
      recaptchaToken: $recaptchaToken
    )
  }
`;
export type InitiateResetPhoneNumberPublicMutationFn = Apollo.MutationFunction<
  Types.InitiateResetPhoneNumberPublicMutation,
  Types.InitiateResetPhoneNumberPublicMutationVariables
>;

/**
 * __useInitiateResetPhoneNumberPublicMutation__
 *
 * To run a mutation, you first call `useInitiateResetPhoneNumberPublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateResetPhoneNumberPublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateResetPhoneNumberPublicMutation, { data, loading, error }] = useInitiateResetPhoneNumberPublicMutation({
 *   variables: {
 *      email: // value for 'email'
 *      currentPhoneNumber: // value for 'currentPhoneNumber'
 *      recaptchaPlatform: // value for 'recaptchaPlatform'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useInitiateResetPhoneNumberPublicMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.InitiateResetPhoneNumberPublicMutation,
    Types.InitiateResetPhoneNumberPublicMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.InitiateResetPhoneNumberPublicMutation,
    Types.InitiateResetPhoneNumberPublicMutationVariables
  >(InitiateResetPhoneNumberPublicDocument, options);
}
export type InitiateResetPhoneNumberPublicMutationHookResult = ReturnType<
  typeof useInitiateResetPhoneNumberPublicMutation
>;
export type InitiateResetPhoneNumberPublicMutationResult = Apollo.MutationResult<
  Types.InitiateResetPhoneNumberPublicMutation
>;
export type InitiateResetPhoneNumberPublicMutationOptions = Apollo.BaseMutationOptions<
  Types.InitiateResetPhoneNumberPublicMutation,
  Types.InitiateResetPhoneNumberPublicMutationVariables
>;
export const MinimumSupportedVersionDocument = gql`
  query MinimumSupportedVersion {
    minimumSupportedVersion {
      ...minimumAppVersion
    }
  }
  ${minimumAppVersionFragmentDoc}
`;

/**
 * __useMinimumSupportedVersionQuery__
 *
 * To run a query within a React component, call `useMinimumSupportedVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinimumSupportedVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinimumSupportedVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useMinimumSupportedVersionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.MinimumSupportedVersionQuery,
    Types.MinimumSupportedVersionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.MinimumSupportedVersionQuery,
    Types.MinimumSupportedVersionQueryVariables
  >(MinimumSupportedVersionDocument, options);
}
export function useMinimumSupportedVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MinimumSupportedVersionQuery,
    Types.MinimumSupportedVersionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.MinimumSupportedVersionQuery,
    Types.MinimumSupportedVersionQueryVariables
  >(MinimumSupportedVersionDocument, options);
}
export type MinimumSupportedVersionQueryHookResult = ReturnType<
  typeof useMinimumSupportedVersionQuery
>;
export type MinimumSupportedVersionLazyQueryHookResult = ReturnType<
  typeof useMinimumSupportedVersionLazyQuery
>;
export type MinimumSupportedVersionQueryResult = Apollo.QueryResult<
  Types.MinimumSupportedVersionQuery,
  Types.MinimumSupportedVersionQueryVariables
>;
export const PublicBankSettlementDocument = gql`
  query PublicBankSettlement($paidyCode: String!) {
    bankSettlement(paidyCode: $paidyCode) {
      bankName
      branchName
      accountType
      accountHolder
      accountNumber
    }
  }
`;

/**
 * __usePublicBankSettlementQuery__
 *
 * To run a query within a React component, call `usePublicBankSettlementQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicBankSettlementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicBankSettlementQuery({
 *   variables: {
 *      paidyCode: // value for 'paidyCode'
 *   },
 * });
 */
export function usePublicBankSettlementQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PublicBankSettlementQuery,
    Types.PublicBankSettlementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PublicBankSettlementQuery,
    Types.PublicBankSettlementQueryVariables
  >(PublicBankSettlementDocument, options);
}
export function usePublicBankSettlementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PublicBankSettlementQuery,
    Types.PublicBankSettlementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PublicBankSettlementQuery,
    Types.PublicBankSettlementQueryVariables
  >(PublicBankSettlementDocument, options);
}
export type PublicBankSettlementQueryHookResult = ReturnType<
  typeof usePublicBankSettlementQuery
>;
export type PublicBankSettlementLazyQueryHookResult = ReturnType<
  typeof usePublicBankSettlementLazyQuery
>;
export type PublicBankSettlementQueryResult = Apollo.QueryResult<
  Types.PublicBankSettlementQuery,
  Types.PublicBankSettlementQueryVariables
>;
export const PublicBillStatementDocument = gql`
  query PublicBillStatement($paidyCode: String!) {
    billStatement(paidyCode: $paidyCode) {
      id
      unpaidAmount
      lateFeeAmount
      outstandingAmount
      combiniSettlementAvailable
      bankTransferSettlementAvailable
      autoDebitSettlement {
        pullAmount
        pullStatus
        resultsProcessedBy
      }
      dueAt
      paidAt
      status
    }
  }
`;

/**
 * __usePublicBillStatementQuery__
 *
 * To run a query within a React component, call `usePublicBillStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicBillStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicBillStatementQuery({
 *   variables: {
 *      paidyCode: // value for 'paidyCode'
 *   },
 * });
 */
export function usePublicBillStatementQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PublicBillStatementQuery,
    Types.PublicBillStatementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PublicBillStatementQuery,
    Types.PublicBillStatementQueryVariables
  >(PublicBillStatementDocument, options);
}
export function usePublicBillStatementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PublicBillStatementQuery,
    Types.PublicBillStatementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PublicBillStatementQuery,
    Types.PublicBillStatementQueryVariables
  >(PublicBillStatementDocument, options);
}
export type PublicBillStatementQueryHookResult = ReturnType<
  typeof usePublicBillStatementQuery
>;
export type PublicBillStatementLazyQueryHookResult = ReturnType<
  typeof usePublicBillStatementLazyQuery
>;
export type PublicBillStatementQueryResult = Apollo.QueryResult<
  Types.PublicBillStatementQuery,
  Types.PublicBillStatementQueryVariables
>;
export const PublicCombiniSettlementDocument = gql`
  query PublicCombiniSettlement($paidyCode: String!, $isFamilyMart: Boolean) {
    combiniSettlement(paidyCode: $paidyCode, isFamilyMart: $isFamilyMart) {
      amount
      settlementFeeAmount
      currency
      codes {
        consumerCode
        merchantCode
        store
      }
    }
  }
`;

/**
 * __usePublicCombiniSettlementQuery__
 *
 * To run a query within a React component, call `usePublicCombiniSettlementQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicCombiniSettlementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCombiniSettlementQuery({
 *   variables: {
 *      paidyCode: // value for 'paidyCode'
 *      isFamilyMart: // value for 'isFamilyMart'
 *   },
 * });
 */
export function usePublicCombiniSettlementQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.PublicCombiniSettlementQuery,
    Types.PublicCombiniSettlementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PublicCombiniSettlementQuery,
    Types.PublicCombiniSettlementQueryVariables
  >(PublicCombiniSettlementDocument, options);
}
export function usePublicCombiniSettlementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PublicCombiniSettlementQuery,
    Types.PublicCombiniSettlementQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PublicCombiniSettlementQuery,
    Types.PublicCombiniSettlementQueryVariables
  >(PublicCombiniSettlementDocument, options);
}
export type PublicCombiniSettlementQueryHookResult = ReturnType<
  typeof usePublicCombiniSettlementQuery
>;
export type PublicCombiniSettlementLazyQueryHookResult = ReturnType<
  typeof usePublicCombiniSettlementLazyQuery
>;
export type PublicCombiniSettlementQueryResult = Apollo.QueryResult<
  Types.PublicCombiniSettlementQuery,
  Types.PublicCombiniSettlementQueryVariables
>;
export const PublicCreateSingleBillNumericCodeV3Document = gql`
  query PublicCreateSingleBillNumericCodeV3(
    $billId: String!
    $cvsStoreId: String!
  ) {
    createSinglebillNumericCodeV3(billId: $billId, cvsStoreId: $cvsStoreId) {
      amount
      settlementFeeAmount
      currency
      codes {
        consumerCode
        merchantCode
        store
      }
    }
  }
`;

/**
 * __usePublicCreateSingleBillNumericCodeV3Query__
 *
 * To run a query within a React component, call `usePublicCreateSingleBillNumericCodeV3Query` and pass it any options that fit your needs.
 * When your component renders, `usePublicCreateSingleBillNumericCodeV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCreateSingleBillNumericCodeV3Query({
 *   variables: {
 *      billId: // value for 'billId'
 *      cvsStoreId: // value for 'cvsStoreId'
 *   },
 * });
 */
export function usePublicCreateSingleBillNumericCodeV3Query(
  baseOptions: Apollo.QueryHookOptions<
    Types.PublicCreateSingleBillNumericCodeV3Query,
    Types.PublicCreateSingleBillNumericCodeV3QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PublicCreateSingleBillNumericCodeV3Query,
    Types.PublicCreateSingleBillNumericCodeV3QueryVariables
  >(PublicCreateSingleBillNumericCodeV3Document, options);
}
export function usePublicCreateSingleBillNumericCodeV3LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PublicCreateSingleBillNumericCodeV3Query,
    Types.PublicCreateSingleBillNumericCodeV3QueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PublicCreateSingleBillNumericCodeV3Query,
    Types.PublicCreateSingleBillNumericCodeV3QueryVariables
  >(PublicCreateSingleBillNumericCodeV3Document, options);
}
export type PublicCreateSingleBillNumericCodeV3QueryHookResult = ReturnType<
  typeof usePublicCreateSingleBillNumericCodeV3Query
>;
export type PublicCreateSingleBillNumericCodeV3LazyQueryHookResult = ReturnType<
  typeof usePublicCreateSingleBillNumericCodeV3LazyQuery
>;
export type PublicCreateSingleBillNumericCodeV3QueryResult = Apollo.QueryResult<
  Types.PublicCreateSingleBillNumericCodeV3Query,
  Types.PublicCreateSingleBillNumericCodeV3QueryVariables
>;
export const PublicFeaturesDocument = gql`
  query PublicFeatures {
    publicFeatures {
      ...publicFeatures
    }
  }
  ${publicFeaturesFragmentDoc}
`;

/**
 * __usePublicFeaturesQuery__
 *
 * To run a query within a React component, call `usePublicFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicFeaturesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.PublicFeaturesQuery,
    Types.PublicFeaturesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.PublicFeaturesQuery,
    Types.PublicFeaturesQueryVariables
  >(PublicFeaturesDocument, options);
}
export function usePublicFeaturesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.PublicFeaturesQuery,
    Types.PublicFeaturesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.PublicFeaturesQuery,
    Types.PublicFeaturesQueryVariables
  >(PublicFeaturesDocument, options);
}
export type PublicFeaturesQueryHookResult = ReturnType<
  typeof usePublicFeaturesQuery
>;
export type PublicFeaturesLazyQueryHookResult = ReturnType<
  typeof usePublicFeaturesLazyQuery
>;
export type PublicFeaturesQueryResult = Apollo.QueryResult<
  Types.PublicFeaturesQuery,
  Types.PublicFeaturesQueryVariables
>;
export const RefreshAuthDocument = gql`
  mutation RefreshAuth($refreshToken: String!) {
    refreshAuth(refreshToken: $refreshToken) {
      ...tokensResponse
    }
  }
  ${tokensResponseFragmentDoc}
`;
export type RefreshAuthMutationFn = Apollo.MutationFunction<
  Types.RefreshAuthMutation,
  Types.RefreshAuthMutationVariables
>;

/**
 * __useRefreshAuthMutation__
 *
 * To run a mutation, you first call `useRefreshAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAuthMutation, { data, loading, error }] = useRefreshAuthMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshAuthMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RefreshAuthMutation,
    Types.RefreshAuthMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RefreshAuthMutation,
    Types.RefreshAuthMutationVariables
  >(RefreshAuthDocument, options);
}
export type RefreshAuthMutationHookResult = ReturnType<
  typeof useRefreshAuthMutation
>;
export type RefreshAuthMutationResult = Apollo.MutationResult<
  Types.RefreshAuthMutation
>;
export type RefreshAuthMutationOptions = Apollo.BaseMutationOptions<
  Types.RefreshAuthMutation,
  Types.RefreshAuthMutationVariables
>;
export const RequestTokenDocument = gql`
  mutation RequestToken(
    $email: String!
    $phone: String!
    $pinCodeDispatchMethod: PinCodeDispatchMethod!
  ) {
    requestToken(
      email: $email
      phone: $phone
      pinCodeDispatchMethod: $pinCodeDispatchMethod
    ) {
      ...pin
    }
  }
  ${pinFragmentDoc}
`;
export type RequestTokenMutationFn = Apollo.MutationFunction<
  Types.RequestTokenMutation,
  Types.RequestTokenMutationVariables
>;

/**
 * __useRequestTokenMutation__
 *
 * To run a mutation, you first call `useRequestTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTokenMutation, { data, loading, error }] = useRequestTokenMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      pinCodeDispatchMethod: // value for 'pinCodeDispatchMethod'
 *   },
 * });
 */
export function useRequestTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RequestTokenMutation,
    Types.RequestTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RequestTokenMutation,
    Types.RequestTokenMutationVariables
  >(RequestTokenDocument, options);
}
export type RequestTokenMutationHookResult = ReturnType<
  typeof useRequestTokenMutation
>;
export type RequestTokenMutationResult = Apollo.MutationResult<
  Types.RequestTokenMutation
>;
export type RequestTokenMutationOptions = Apollo.BaseMutationOptions<
  Types.RequestTokenMutation,
  Types.RequestTokenMutationVariables
>;
export const RequestTokenAndroidDocument = gql`
  mutation RequestTokenAndroid(
    $email: String!
    $phone: String!
    $pinCodeDispatchMethod: PinCodeDispatchMethod!
    $recaptchaToken: String!
  ) {
    requestTokenAndroid(
      email: $email
      phone: $phone
      pinCodeDispatchMethod: $pinCodeDispatchMethod
      recaptchaToken: $recaptchaToken
    ) {
      ...pin
    }
  }
  ${pinFragmentDoc}
`;
export type RequestTokenAndroidMutationFn = Apollo.MutationFunction<
  Types.RequestTokenAndroidMutation,
  Types.RequestTokenAndroidMutationVariables
>;

/**
 * __useRequestTokenAndroidMutation__
 *
 * To run a mutation, you first call `useRequestTokenAndroidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTokenAndroidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTokenAndroidMutation, { data, loading, error }] = useRequestTokenAndroidMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      pinCodeDispatchMethod: // value for 'pinCodeDispatchMethod'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useRequestTokenAndroidMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RequestTokenAndroidMutation,
    Types.RequestTokenAndroidMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RequestTokenAndroidMutation,
    Types.RequestTokenAndroidMutationVariables
  >(RequestTokenAndroidDocument, options);
}
export type RequestTokenAndroidMutationHookResult = ReturnType<
  typeof useRequestTokenAndroidMutation
>;
export type RequestTokenAndroidMutationResult = Apollo.MutationResult<
  Types.RequestTokenAndroidMutation
>;
export type RequestTokenAndroidMutationOptions = Apollo.BaseMutationOptions<
  Types.RequestTokenAndroidMutation,
  Types.RequestTokenAndroidMutationVariables
>;
export const RequestTokenIosDocument = gql`
  mutation RequestTokenIos(
    $email: String!
    $phone: String!
    $pinCodeDispatchMethod: PinCodeDispatchMethod!
    $recaptchaToken: String!
  ) {
    requestTokenIos(
      email: $email
      phone: $phone
      pinCodeDispatchMethod: $pinCodeDispatchMethod
      recaptchaToken: $recaptchaToken
    ) {
      ...pin
    }
  }
  ${pinFragmentDoc}
`;
export type RequestTokenIosMutationFn = Apollo.MutationFunction<
  Types.RequestTokenIosMutation,
  Types.RequestTokenIosMutationVariables
>;

/**
 * __useRequestTokenIosMutation__
 *
 * To run a mutation, you first call `useRequestTokenIosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTokenIosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTokenIosMutation, { data, loading, error }] = useRequestTokenIosMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      pinCodeDispatchMethod: // value for 'pinCodeDispatchMethod'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useRequestTokenIosMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RequestTokenIosMutation,
    Types.RequestTokenIosMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RequestTokenIosMutation,
    Types.RequestTokenIosMutationVariables
  >(RequestTokenIosDocument, options);
}
export type RequestTokenIosMutationHookResult = ReturnType<
  typeof useRequestTokenIosMutation
>;
export type RequestTokenIosMutationResult = Apollo.MutationResult<
  Types.RequestTokenIosMutation
>;
export type RequestTokenIosMutationOptions = Apollo.BaseMutationOptions<
  Types.RequestTokenIosMutation,
  Types.RequestTokenIosMutationVariables
>;
export const ConfirmTokenDocument = gql`
  mutation ConfirmToken($token: String!, $pinCode: String!) {
    confirmToken(token: $token, pinCode: $pinCode) {
      ...pin
    }
  }
  ${pinFragmentDoc}
`;
export type ConfirmTokenMutationFn = Apollo.MutationFunction<
  Types.ConfirmTokenMutation,
  Types.ConfirmTokenMutationVariables
>;

/**
 * __useConfirmTokenMutation__
 *
 * To run a mutation, you first call `useConfirmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTokenMutation, { data, loading, error }] = useConfirmTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      pinCode: // value for 'pinCode'
 *   },
 * });
 */
export function useConfirmTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.ConfirmTokenMutation,
    Types.ConfirmTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.ConfirmTokenMutation,
    Types.ConfirmTokenMutationVariables
  >(ConfirmTokenDocument, options);
}
export type ConfirmTokenMutationHookResult = ReturnType<
  typeof useConfirmTokenMutation
>;
export type ConfirmTokenMutationResult = Apollo.MutationResult<
  Types.ConfirmTokenMutation
>;
export type ConfirmTokenMutationOptions = Apollo.BaseMutationOptions<
  Types.ConfirmTokenMutation,
  Types.ConfirmTokenMutationVariables
>;
export const RespondToAuthChallengeDocument = gql`
  mutation RespondToAuthChallenge($answer: String!, $session: String!) {
    respondToAuthChallenge(answer: $answer, session: $session) {
      ...authResponse
    }
  }
  ${authResponseFragmentDoc}
`;
export type RespondToAuthChallengeMutationFn = Apollo.MutationFunction<
  Types.RespondToAuthChallengeMutation,
  Types.RespondToAuthChallengeMutationVariables
>;

/**
 * __useRespondToAuthChallengeMutation__
 *
 * To run a mutation, you first call `useRespondToAuthChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToAuthChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToAuthChallengeMutation, { data, loading, error }] = useRespondToAuthChallengeMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *      session: // value for 'session'
 *   },
 * });
 */
export function useRespondToAuthChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RespondToAuthChallengeMutation,
    Types.RespondToAuthChallengeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RespondToAuthChallengeMutation,
    Types.RespondToAuthChallengeMutationVariables
  >(RespondToAuthChallengeDocument, options);
}
export type RespondToAuthChallengeMutationHookResult = ReturnType<
  typeof useRespondToAuthChallengeMutation
>;
export type RespondToAuthChallengeMutationResult = Apollo.MutationResult<
  Types.RespondToAuthChallengeMutation
>;
export type RespondToAuthChallengeMutationOptions = Apollo.BaseMutationOptions<
  Types.RespondToAuthChallengeMutation,
  Types.RespondToAuthChallengeMutationVariables
>;
export const RespondToMyEmailReminderChallengeDocument = gql`
  mutation RespondToMyEmailReminderChallenge(
    $session: String!
    $answer: String!
    $recaptchaPlatform: Platform!
    $recaptchaToken: String!
  ) {
    respondToMyEmailReminderChallenge(
      session: $session
      answer: $answer
      recaptchaPlatform: $recaptchaPlatform
      recaptchaToken: $recaptchaToken
    )
  }
`;
export type RespondToMyEmailReminderChallengeMutationFn = Apollo.MutationFunction<
  Types.RespondToMyEmailReminderChallengeMutation,
  Types.RespondToMyEmailReminderChallengeMutationVariables
>;

/**
 * __useRespondToMyEmailReminderChallengeMutation__
 *
 * To run a mutation, you first call `useRespondToMyEmailReminderChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToMyEmailReminderChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToMyEmailReminderChallengeMutation, { data, loading, error }] = useRespondToMyEmailReminderChallengeMutation({
 *   variables: {
 *      session: // value for 'session'
 *      answer: // value for 'answer'
 *      recaptchaPlatform: // value for 'recaptchaPlatform'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useRespondToMyEmailReminderChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.RespondToMyEmailReminderChallengeMutation,
    Types.RespondToMyEmailReminderChallengeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.RespondToMyEmailReminderChallengeMutation,
    Types.RespondToMyEmailReminderChallengeMutationVariables
  >(RespondToMyEmailReminderChallengeDocument, options);
}
export type RespondToMyEmailReminderChallengeMutationHookResult = ReturnType<
  typeof useRespondToMyEmailReminderChallengeMutation
>;
export type RespondToMyEmailReminderChallengeMutationResult = Apollo.MutationResult<
  Types.RespondToMyEmailReminderChallengeMutation
>;
export type RespondToMyEmailReminderChallengeMutationOptions = Apollo.BaseMutationOptions<
  Types.RespondToMyEmailReminderChallengeMutation,
  Types.RespondToMyEmailReminderChallengeMutationVariables
>;
export const UnpaidBillStatementsDocument = gql`
  query UnpaidBillStatements($paidyCode: String!) {
    unpaidBillStatements(paidyCode: $paidyCode) {
      ...publicUnpaidBillStatements
    }
  }
  ${publicUnpaidBillStatementsFragmentDoc}
`;

/**
 * __useUnpaidBillStatementsQuery__
 *
 * To run a query within a React component, call `useUnpaidBillStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnpaidBillStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnpaidBillStatementsQuery({
 *   variables: {
 *      paidyCode: // value for 'paidyCode'
 *   },
 * });
 */
export function useUnpaidBillStatementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.UnpaidBillStatementsQuery,
    Types.UnpaidBillStatementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.UnpaidBillStatementsQuery,
    Types.UnpaidBillStatementsQueryVariables
  >(UnpaidBillStatementsDocument, options);
}
export function useUnpaidBillStatementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.UnpaidBillStatementsQuery,
    Types.UnpaidBillStatementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.UnpaidBillStatementsQuery,
    Types.UnpaidBillStatementsQueryVariables
  >(UnpaidBillStatementsDocument, options);
}
export type UnpaidBillStatementsQueryHookResult = ReturnType<
  typeof useUnpaidBillStatementsQuery
>;
export type UnpaidBillStatementsLazyQueryHookResult = ReturnType<
  typeof useUnpaidBillStatementsLazyQuery
>;
export type UnpaidBillStatementsQueryResult = Apollo.QueryResult<
  Types.UnpaidBillStatementsQuery,
  Types.UnpaidBillStatementsQueryVariables
>;
